/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneParagraph from 'sites/allas/components/standalone/Paragraph';

export const DynamicStandaloneParagraph = StandaloneParagraph;
export type DynamicStandaloneParagraphProps = PropsFromComponent<typeof StandaloneParagraph>;

export const DynamicStandaloneParagraphWith = (extras: DynamicStandaloneExtras): typeof StandaloneParagraph => {
    return function DynamicStandaloneParagraph(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Paragraph');
        return <StandaloneParagraph {...mergeProps({ options: { theme } }, props)} />;
    }
}